import type { CheckoutCardSlots } from '../ui/card_slots.js';
import { BusCheckoutCard } from './bus/bus_checkout_card.js';
import { FlightCheckoutCard } from './flight/flight_checkout_card.js';
import { HotelCheckoutCard } from './hotel/hotel_checkout_card.js';
import { MobilityCheckoutCard } from './mobility/mobility_checkout_card.js';
import { RentalCheckoutCard } from './rental/rental_checkout_card.js';
import { itemsOf } from '@voll-intelligence/intelligence-ui-kit/checkout';

/** O card de checkout de cada produto: o ÚNICO lugar do fluxo do card que
 *  escolhe pelo `productType`. O carrinho é de um produto só (o 1º item manda);
 *  cada composição recebe só os itens dele. */
export function ProductCheckoutCardContent({ slots }: { readonly slots: CheckoutCardSlots }) {
  const { items } = slots.checkout;
  const [first] = items;
  if (!first) return null;
  switch (first.productType) {
    case 'flight':
      return <FlightCheckoutCard items={itemsOf(items, 'flight')} slots={slots} />;
    case 'hotel':
      return <HotelCheckoutCard items={itemsOf(items, 'hotel')} slots={slots} />;
    case 'bus':
      return <BusCheckoutCard items={itemsOf(items, 'bus')} slots={slots} />;
    case 'rental':
      return <RentalCheckoutCard items={itemsOf(items, 'rental')} slots={slots} />;
    case 'mobility':
      return <MobilityCheckoutCard items={itemsOf(items, 'mobility')} slots={slots} />;
    default:
      return unhandledCase(first);
  }
}

/** Um `productType` não tratado não COMPILA; em runtime, um valor fora do tipo não renderiza
 *  nada em vez de entregar um objeto cru ao React. */
function unhandledCase(_value: never): null {
  return null;
}
